import { z } from "zod";
import type { ExercisePauseState } from "./exercise-pause";

export const REFLECTION_EXERCISES = [
  { type: "mathe", label: "Rechentraining" },
  { type: "einmaleins", label: "Einmaleins" },
  { type: "rechenmauer", label: "Rechenmauer" },
  { type: "stellenwert-addition", label: "Stellenwert-Addition", hint: "Vor der abschließenden Rechenwegprüfung" },
  { type: "runden", label: "Runden" },
  { type: "transkodieren", label: "Transkodieren", hint: "Nur bei Zahleneingabe, nicht bei direkter Antwortauswahl" },
  { type: "zahlen-zerlegen", label: "Zahlen zerlegen" },
  { type: "schriftlich-rechnen", label: "Schriftliches Rechnen" },
  { type: "silbentrennung", label: "Silbentrennung" },
  { type: "morphem-stamm", label: "Wortstammtraining" },
  { type: "morphem-zerlegung", label: "Wortbausteine zerlegen" },
  { type: "wortarten", label: "Wortarten" },
  { type: "grossklein", label: "Groß- und Kleinschreibung" },
  { type: "satzglieder", label: "Satzglieder" },
  { type: "zeitformen-konjugieren", label: "Zeitformen konjugieren" },
  { type: "quiz", label: "Quiz", hint: "Eine Denkpause vor der gesamten Auswertung" },
  { type: "lueckentext", label: "Lückentext", hint: "Eine Denkpause vor der gesamten Auswertung" },
] as const;
export const reflectionExerciseTypeSchema = z.enum(REFLECTION_EXERCISES.map((entry) => entry.type));
export const reflectionSettingsSchema = z.object({
  enabled: z.boolean(),
  durationSeconds: z.number({ error: "Bitte eine Dauer von 1 bis 60 Sekunden eingeben." }).int("Bitte ganze Sekunden eingeben.").min(1, "Die Denkpause dauert mindestens 1 Sekunde.").max(60, "Die Denkpause dauert höchstens 60 Sekunden."),
  exerciseTypes: z.array(reflectionExerciseTypeSchema).max(17),
}).strict().refine((value) => !value.enabled || value.exerciseTypes.length > 0, "Bitte mindestens einen Aufgabentyp auswählen.")
  .refine((value) => new Set(value.exerciseTypes).size === value.exerciseTypes.length, "Aufgabentypen dürfen nur einmal ausgewählt werden.");
export type ReflectionSettings = z.infer<typeof reflectionSettingsSchema>;
export function reflectionSettingsFrom(value: unknown): ReflectionSettings {
  const parsed = reflectionSettingsSchema.safeParse(value);
  return parsed.success ? parsed.data : { enabled: false, durationSeconds: 5, exerciseTypes: [] };
}
export function runReflectionSettings(settings: unknown) {
  return reflectionSettingsFrom((settings as { reflection?: unknown } | null)?.reflection);
}
export interface ReflectionState {
  runId: string;
  enabled: boolean;
  required: boolean;
  revision: number;
  active: boolean;
  approved: boolean;
  until: number | null;
  paused: boolean;
  pause: ExercisePauseState;
}
